var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Send, X, Loader2, CheckCircle, Clock, AlertCircle, Image as ImageIcon } from 'lucide-react';
import { getFeedback, addFeedbackMessage } from '../actions/feedbacks';
import { showToast } from '../utils/toastUtils';
var STATUS_COLORS = {
    pending: { bg: 'bg-yellow-500/20', text: 'text-yellow-400', icon: Clock },
    under_review: { bg: 'bg-blue-500/20', text: 'text-blue-400', icon: AlertCircle },
    in_progress: { bg: 'bg-purple-500/20', text: 'text-purple-400', icon: Loader2 },
    resolved: { bg: 'bg-green-500/20', text: 'text-green-400', icon: CheckCircle },
    rejected: { bg: 'bg-red-500/20', text: 'text-red-400', icon: X },
};
var FeedbackThread = function () {
    var _a;
    var feedbackId = useParams().feedbackId;
    var navigate = useNavigate();
    var messagesEndRef = useRef(null);
    var fileInputRef = useRef(null);
    var _b = useState(null), feedback = _b[0], setFeedback = _b[1];
    var _c = useState(true), loading = _c[0], setLoading = _c[1];
    var _d = useState(''), message = _d[0], setMessage = _d[1];
    var _e = useState(null), screenshot = _e[0], setScreenshot = _e[1];
    var _f = useState(null), screenshotPreview = _f[0], setScreenshotPreview = _f[1];
    var _g = useState(false), sending = _g[0], setSending = _g[1];
    useEffect(function () {
        if (feedbackId) {
            loadFeedback();
        }
    }, [feedbackId]);
    useEffect(function () {
        scrollToBottom();
    }, [feedback === null || feedback === void 0 ? void 0 : feedback.messages]);
    var loadFeedback = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, getFeedback(feedbackId)];
                case 2:
                    data = _a.sent();
                    setFeedback(data);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    console.error('Erro ao carregar feedback:', error_1);
                    showToast('error', 'Erro ao carregar feedback');
                    navigate('/feedbacks');
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var scrollToBottom = function () {
        var _a;
        (_a = messagesEndRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
    };
    var handleFileChange = function (e) {
        var _a;
        var file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (file) {
            if (file.size > 5 * 1024 * 1024) {
                showToast('error', 'Imagem muito grande (máximo 5MB)');
                return;
            }
            if (!file.type.startsWith('image/')) {
                showToast('error', 'Apenas imagens são aceitas');
                return;
            }
            setScreenshot(file);
            var reader_1 = new FileReader();
            reader_1.onload = function () {
                setScreenshotPreview(reader_1.result);
            };
            reader_1.readAsDataURL(file);
        }
    };
    var handleRemoveScreenshot = function () {
        setScreenshot(null);
        setScreenshotPreview(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };
    var handleSendMessage = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    if (!message.trim()) {
                        showToast('error', 'Digite uma mensagem');
                        return [2 /*return*/];
                    }
                    setSending(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, addFeedbackMessage(feedbackId, message.trim(), screenshot || undefined)];
                case 2:
                    _a.sent();
                    setMessage('');
                    setScreenshot(null);
                    setScreenshotPreview(null);
                    return [4 /*yield*/, loadFeedback()];
                case 3:
                    _a.sent();
                    showToast('success', 'Mensagem enviada!');
                    return [3 /*break*/, 6];
                case 4:
                    error_2 = _a.sent();
                    console.error('Erro ao enviar mensagem:', error_2);
                    showToast('error', 'Erro ao enviar mensagem');
                    return [3 /*break*/, 6];
                case 5:
                    setSending(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    if (loading) {
        return (React.createElement("div", { className: "min-h-screen bg-gray-900 flex items-center justify-center" },
            React.createElement("div", { className: "text-center" },
                React.createElement(Loader2, { size: 48, className: "animate-spin text-blue-500 mx-auto mb-4" }),
                React.createElement("p", { className: "text-gray-400" }, "Carregando conversa..."))));
    }
    if (!feedback) {
        return null;
    }
    var StatusIcon = ((_a = STATUS_COLORS[feedback.status]) === null || _a === void 0 ? void 0 : _a.icon) || Clock;
    var statusStyle = STATUS_COLORS[feedback.status] || STATUS_COLORS.pending;
    return (React.createElement("div", { className: "min-h-screen bg-gray-900 flex flex-col" },
        React.createElement("div", { className: "bg-gray-800 border-b border-gray-700 px-6 py-4 sticky top-0 z-10" },
            React.createElement("div", { className: "max-w-5xl mx-auto" },
                React.createElement("button", { onClick: function () { return navigate('/feedbacks'); }, className: "text-gray-400 hover:text-white flex items-center gap-2 mb-3 transition" },
                    React.createElement(ArrowLeft, { size: 20 }),
                    "Voltar"),
                React.createElement("div", { className: "flex flex-col md:flex-row md:items-center md:justify-between gap-4" },
                    React.createElement("div", null,
                        React.createElement("h1", { className: "text-2xl font-bold text-white mb-2" },
                            feedback.type_display,
                            " - ",
                            feedback.title),
                        React.createElement("div", { className: "flex flex-wrap items-center gap-3 text-sm" },
                            React.createElement("span", { className: "".concat(statusStyle.bg, " ").concat(statusStyle.text, " px-3 py-1 rounded-full font-semibold flex items-center gap-1") },
                                React.createElement(StatusIcon, { size: 14 }),
                                feedback.status_display),
                            React.createElement("span", { className: "text-gray-400" },
                                "Prioridade: ",
                                React.createElement("span", { className: "font-semibold text-white" }, feedback.priority_display)),
                            React.createElement("span", { className: "text-gray-500" },
                                "Criado em ",
                                new Date(feedback.created_at).toLocaleDateString('pt-BR', {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit'
                                }))))))),
        React.createElement("div", { className: "flex-1 overflow-y-auto p-6" },
            React.createElement("div", { className: "max-w-5xl mx-auto space-y-4" },
                feedback.messages.map(function (msg) { return (React.createElement("div", { key: msg.id, className: "flex ".concat(msg.is_admin ? 'justify-end' : 'justify-start') },
                    React.createElement("div", { className: "max-w-[70%] ".concat(msg.is_admin ? 'bg-blue-600' : 'bg-gray-800', " rounded-2xl p-4 shadow-lg") },
                        React.createElement("div", { className: "flex items-center gap-2 mb-2" },
                            React.createElement("span", { className: "font-semibold text-sm ".concat(msg.is_admin ? 'text-blue-100' : 'text-gray-400') },
                                msg.is_admin ? '👨‍💼 Admin' : '👤 Você',
                                " - ",
                                msg.sender_name),
                            React.createElement("span", { className: "text-xs ".concat(msg.is_admin ? 'text-blue-200' : 'text-gray-500') }, new Date(msg.created_at).toLocaleTimeString('pt-BR', {
                                hour: '2-digit',
                                minute: '2-digit'
                            }))),
                        React.createElement("p", { className: "".concat(msg.is_admin ? 'text-white' : 'text-gray-200', " whitespace-pre-wrap break-words") }, msg.message),
                        msg.screenshot && (React.createElement("div", { className: "mt-3" },
                            React.createElement("img", { src: "data:image/jpeg;base64,".concat(msg.screenshot), alt: "Screenshot", className: "rounded-lg max-w-full h-auto cursor-pointer hover:opacity-90 transition", onClick: function () { return window.open("data:image/jpeg;base64,".concat(msg.screenshot), '_blank'); } })))))); }),
                React.createElement("div", { ref: messagesEndRef }))),
        React.createElement("div", { className: "bg-gray-800 border-t border-gray-700 p-4 sticky bottom-0" },
            React.createElement("div", { className: "max-w-5xl mx-auto" },
                screenshotPreview && (React.createElement("div", { className: "mb-4 relative inline-block" },
                    React.createElement("img", { src: screenshotPreview, alt: "Preview", className: "max-h-32 rounded-lg border border-gray-600" }),
                    React.createElement("button", { onClick: handleRemoveScreenshot, className: "absolute -top-2 -right-2 bg-red-600 hover:bg-red-700 text-white p-1 rounded-full transition" },
                        React.createElement(X, { size: 16 })))),
                React.createElement("form", { onSubmit: handleSendMessage, className: "flex gap-3" },
                    React.createElement("button", { type: "button", onClick: function () { var _a; return (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, className: "bg-gray-700 hover:bg-gray-600 text-white p-3 rounded-lg transition flex-shrink-0", title: "Anexar imagem" },
                        React.createElement(ImageIcon, { size: 20 })),
                    React.createElement("input", { ref: fileInputRef, type: "file", accept: "image/*", onChange: handleFileChange, className: "hidden" }),
                    React.createElement("input", { type: "text", value: message, onChange: function (e) { return setMessage(e.target.value); }, placeholder: "Digite sua mensagem...", className: "flex-1 bg-gray-700 text-white px-4 py-3 rounded-lg border border-gray-600 focus:outline-none focus:border-blue-400 transition", disabled: sending }),
                    React.createElement("button", { type: "submit", disabled: sending || !message.trim(), className: "bg-blue-600 hover:bg-blue-700 disabled:bg-gray-600 disabled:cursor-not-allowed text-white px-6 py-3 rounded-lg font-semibold flex items-center gap-2 transition" }, sending ? (React.createElement(React.Fragment, null,
                        React.createElement(Loader2, { size: 20, className: "animate-spin" }),
                        "Enviando...")) : (React.createElement(React.Fragment, null,
                        React.createElement(Send, { size: 20 }),
                        "Enviar"))))))));
};
export default FeedbackThread;
